import { render, staticRenderFns } from "./edit_power.vue?vue&type=template&id=6c8339a1&"
import script from "./edit_power.vue?vue&type=script&lang=js&"
export * from "./edit_power.vue?vue&type=script&lang=js&"
import style0 from "./edit_power.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports